import { Injectable, Injector } from "@angular/core";
import { MfAuthService, MfBaseService, MfError, MfModelConfigMapped, MfModelConfigService, MfPortalsClientService, mfStringIsEmptyOrWhitespace, mfTypeHasOwnProperty, MfTypeInfo, mfTypeIsNullOrUndefined, mfTypeIsUndefined } from "@pattonair/material-framework";
import { map, Observable, of, share } from "rxjs";
import { AUC_ENVIRONMENT } from "../environments/environment";
import { AucModelsConfig } from "../modelConfigs/model.config";
import { AucUserApprovedModel } from "../modelConfigs/user.approved.model.config";
import { AucUserModel } from "../modelConfigs/user.model.config";

const TYPE_INFO: MfTypeInfo = { className: "AucUserService" };

@Injectable({ providedIn: "root" })
export class AucUserService extends MfBaseService {
  protected _userApprovedModelConfig: MfModelConfigMapped;
  protected _isApproved?: boolean;
  protected _isApproved$?: Observable<boolean>;

  public constructor(
    protected override _injector: Injector,
    protected _authService: MfAuthService,
    protected _modelConfigService: MfModelConfigService,
    protected _portalsClientService: MfPortalsClientService,
  ) {
    super(TYPE_INFO, _injector);
    this._userApprovedModelConfig = this._modelConfigService.get<AucModelsConfig>("userApproved");
    this._sub(this._authService.onLoggedOut, {
      next: () => {
        delete this._isApproved;
        delete this._isApproved$;
      }
    });
  }

  public get isApproved(): Observable<boolean> {
    if (!mfTypeIsUndefined(this._isApproved)) {
      return of(this._isApproved);
    } else {
      if (mfTypeIsUndefined(this._isApproved$)) {
        this._isApproved$ = this._portalsClientService.getItemGet<AucUserApprovedModel>(
          this._userApprovedModelConfig,
          `${AUC_ENVIRONMENT.portalsUserRootUrl}/MyAccount/User/Check`
        ).pipe(
          map((userApproved) => {
            this._isApproved = userApproved.active;
            return this._isApproved;
          }),
          share(),
        );
      }
      return this._isApproved$;
    }
  }

  public getUser(): AucUserModel {
    const userClaims = this._authService.getIdentityClaims();

    if (!mfTypeIsNullOrUndefined(userClaims) &&
      (
        mfTypeHasOwnProperty(userClaims, "given_name") &&
        mfTypeHasOwnProperty(userClaims, "family_name") &&
        mfTypeHasOwnProperty(userClaims, "http://schemas.microsoft.com/identity/claims/email")
      )
    ) {
      const givenName = userClaims.given_name as string;
      const surname = userClaims.family_name as string;
      const mail = userClaims["http://schemas.microsoft.com/identity/claims/email"] as string;

      const user: AucUserModel = { givenName, surname, mail, };
      user.displayName = "";

      if (!mfStringIsEmptyOrWhitespace(givenName)) {
        user.displayName += givenName;
      }

      if (!mfStringIsEmptyOrWhitespace(surname)) {
        user.displayName += " " + surname;
      }

      if (!mfStringIsEmptyOrWhitespace(givenName) && !mfStringIsEmptyOrWhitespace(surname)) {
        user.initials = `${givenName.charAt(0)}${surname?.charAt(0)}`;
      }

      return user;
    }

    throw new MfError(this._typeInfo, "getUser", "Unable to get user data from user claims");
  }
}